"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvideComponentServiceFactory = void 0;
const services_definitions_1 = require("@wix/services-definitions");
const definition_js_1 = require("./definition.js");
const react_1 = require("react");
exports.ProvideComponentServiceFactory = (0, services_definitions_1.implementService)(definition_js_1.ProvideComponentServiceDefinition, ({ config }) => {
    const topComponents = config.topComponents || [];
    const bottomComponents = config.bottomComponents || [];
    const addTopComponent = (Comp) => {
        topComponents.push(Comp);
    };
    const addBottomComponent = (Comp) => {
        bottomComponents.push(Comp);
    };
    const getAllTopComponents = () => () => (0, react_1.createElement)(react_1.Fragment, null, topComponents.map((Comp, index) => (0, react_1.createElement)(Comp, { key: index })));
    const getAllBottomComponents = () => () => (0, react_1.createElement)(react_1.Fragment, null, bottomComponents.map((Comp, index) => (0, react_1.createElement)(Comp, { key: index })));
    return {
        addTopComponent,
        addBottomComponent,
        getAllTopComponents,
        getAllBottomComponents,
    };
});
